import { useEffect } from "react";
import useAppDialog from "components/v2/organisms/app-dialog/AppDialog.hook";
import { useMediaQuery, useTheme } from "@mui/material";
import AppDialog, { AppDialogProps } from "components/v2/organisms/app-dialog/AppDialog";
import { PageProps } from "pages/_app";
import { useRouter } from "next/router";
import { API_URL } from "helpers/common";
import ContactUs, { ContactUsProps } from "components/v2/templates/open-tax/contact-us";

function Contact(props: PageProps) {
    const router = useRouter();
    const dialog = useAppDialog(true);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), {
        defaultMatches: true,
    });

    const appDialogProps: AppDialogProps = {
        ...dialog.appDialogProps,
        dialogProps: {
            ...dialog.appDialogProps.dialogProps,
            sx: {
                "& .MuiDialog-paper": {
                    height: { xs: "100%", sm: "auto" },
                    maxHeight: { xs: "100%", sm: "auto" },
                    ...(isMobile && {
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                    }),
                },
            },
        },
        fullHeight: false,
        preventClose: true,
        centerPopup: true,
        backButtonProps: {
            onClick: () => {
                if (router?.query?.page) {
                    location.href = API_URL + "/portal/v2/" + router?.query?.page;
                } else {
                    router.back();
                }
            },
        },
    };

    useEffect(() => {
        dialog.open();
        return () => {
            dialog.close();
        };
    }, []);

    const contactUsProps: ContactUsProps = {
        page: router?.query?.page as string,
        pageProps: props,
    };

    return (
        <AppDialog {...appDialogProps}>
            <ContactUs {...contactUsProps} />
        </AppDialog>
    );
}

export default Contact;
